import React from 'react'
import { Box, Button, Paper } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import SaveIcon from '@mui/icons-material/Save'
import SendIcon from '@mui/icons-material/Send'

const WizardNavigationMobile = ({
    activeStep,
    totalSteps,
    onNext,
    onBack,
    onSaveDraft,
    onSubmitIntent,
    isDraftSaved,
    mode,
}) => {
    return (
        <Paper
            elevation={6}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1100,
                borderTop: 1,
                borderColor: 'divider',
                bgcolor: 'background.paper',
            }}>
            <Box sx={{ py: 1, px: 1.5, display: 'flex', gap: 1.5, maxWidth: 'md', mx: 'auto' }}>
                {activeStep > 0 && (
                    <Button
                        type="button"
                        variant="outlined"
                        onClick={onBack}
                        sx={{
                            flex: 1,
                            height: 42,
                            borderRadius: 2,
                            borderColor: 'divider',
                            color: 'text.primary',
                        }}>
                        <NavigateBeforeIcon sx={{ mr: 0.5 }} />
                        Anterior
                    </Button>
                )}

                {/* Save Draft Button only on Step 0 */}
                {activeStep === 0 && (
                    <Button
                        type="button"
                        variant="outlined"
                        onClick={onSaveDraft}
                        sx={{
                            minWidth: 42,
                            height: 42,
                            borderRadius: 2,
                            borderColor: 'divider',
                            color: 'text.secondary',
                        }}>
                        <SaveIcon fontSize="small" />
                    </Button>
                )}

                {activeStep < totalSteps - 1 ? (
                    <Button
                        type="button"
                        variant="contained"
                        onClick={onNext}
                        sx={{
                            flex: 2,
                            height: 42,
                            borderRadius: 2,
                            bgcolor: 'primary.main',
                            color: 'primary.contrastText',
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: 'primary.dark',
                            },
                        }}>
                        Siguiente
                        <NavigateNextIcon sx={{ ml: 0.5 }} />
                    </Button>
                ) : (
                    <Button
                        type="button"
                        variant="contained"
                        color="success"
                        onClick={onSubmitIntent}
                        sx={{
                            flex: 2,
                            height: 42,
                            borderRadius: 2,
                            fontWeight: 600,
                        }}>
                        <SendIcon sx={{ mr: 0.5 }} fontSize="small" />
                        Confirmar
                    </Button>
                )}
            </Box>
        </Paper>
    )
}

export default WizardNavigationMobile
